import { unsortedWorksheetsUrl } from '../../../urls';

export const unsortedWorksheetCollectionEmailsUrl = () =>
  `${unsortedWorksheetsUrl()}/collection-emails`;
